import { render } from "./eventosejemplo.vue?vue&type=template&id=1793db68&scoped=true"
import script from "./eventosejemplo.vue?vue&type=script&lang=js"
export * from "./eventosejemplo.vue?vue&type=script&lang=js"

import "./eventosejemplo.vue?vue&type=style&index=0&id=1793db68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1793db68"]])

export default __exports__